import React from 'react'
import { VideoControlButton } from './VideoControlButton'
import { SEVV_PRIMARY_CSS } from '../../theme/sevvDialogChrome'
import { HandIcon } from './HandRaisedIndicator'

export interface RaiseHandButtonProps {
  raised: boolean
  onToggle: () => void
  /** True until the Colyseus room is known, so the button is never a silent no-op. */
  disabled?: boolean
}

/** Raise/lower hand control shared by the screen-share and whiteboard views. */
export const RaiseHandButton: React.FC<RaiseHandButtonProps> = ({ raised, onToggle, disabled = false }) => {
  const label = raised ? 'Lower hand' : 'Raise hand'
  return (
    <VideoControlButton
      type="button"
      active={raised}
      onClick={onToggle}
      disabled={disabled}
      aria-label={label}
      aria-pressed={raised}
      title={label}
      style={{
        width: '40px',
        height: '40px',
        backgroundColor: raised ? SEVV_PRIMARY_CSS : 'rgba(0, 0, 0, 0.6)',
        border: raised ? `2px solid ${SEVV_PRIMARY_CSS}` : 'none',
      }}
      data-testid="raise-hand-button"
    >
      <HandIcon size={18} />
    </VideoControlButton>
  )
}

export default RaiseHandButton
